export default __webpack_public_path__ + "static/phone-5b9e9d67d59fb6086e4c439b6d288459.png";